// Shared by table-header.js (the table's Ação column) and AuditLogDetailDialog.jsx, so a log's
// action always reads the same in both places.

// SPEC-AUDIT-007 FR-11: local fallback for an `audit:`-prefixed action with no matching
// translation key (a new action shipped before its locale entry, or a namespace this page's
// i18n.js registration hasn't picked up yet) — humanizes the trailing segment rather than
// rendering the raw, untranslated key. Mirrors AssessmentTimeline.jsx's own t()/defaultValue
// pattern; deliberately local to this page, not a global i18next missingKeyHandler.
const humanizeActionFallback = (action) => {
  const key = action.replace(/^audit:/, '');
  const segment = key.split('.').pop() || key;
  const spaced = segment.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_-]+/g, ' ').trim();
  return spaced.length ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : 'Unknown action';
};

// Interpolation values come from dataAfterAction — already PII-masked by the API (write-time
// for new-shape records, on read for legacy ones), so a name in the label renders masked too.
export const resolveActionLabel = (t, item) => {
  const action = item?.action;
  if (!action?.startsWith('audit:')) return action ?? '';
  let payload = {};
  if (typeof item.dataAfterAction === 'string' && item.dataAfterAction) {
    try {
      payload = JSON.parse(item.dataAfterAction) ?? {};
    } catch {
      // Corrupt or non-JSON legacy payload — render without interpolation rather than break
      payload = {};
    }
  }
  return t(action, { ...payload, defaultValue: humanizeActionFallback(action) });
};
